/**
 * Gravity Forms Query String Field Population
 *
 * Find any hidden Gravity Forms fields with a data-query-param attribute and updates
 * their value to match the corresponding URL query parameter.
 *
 * This is to ensure that fields are populated correctly even when the page is cached with old pre-populated values.
 */
(function() {
    const params = new URLSearchParams(window.location.search);

    if (!params.size) return;

    document.querySelectorAll('[data-query-param]').forEach(function(input) {
        const paramName = input.getAttribute('data-query-param');

        if (params.has(paramName)) {
            input.value = params.get(paramName);
        }
    });
})();



// WEBPACK FOOTER //
// ./src/js/gravity-forms-query-string-field-population.js